<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper, sharedHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { PRODUCT_PRINTER_PROOF_MODULE } from '@/state/modules/productPrinterProof'
import { lookupMethods, productPrinterProofMethods } from "@/state/helpers";
import Multiselect from "vue-multiselect";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    page: {
        title: i18n.t("label.updateX", [i18n.t("module.printerProof")]),
    },
    components: { Layout, PageHeader, Multiselect, DatePicker },
    beforeRouteLeave(to, from, next) {
        if (to.name != "Product-printer-proof-listing") {
            sessionHelper.clearSearch(SESSION.PRODUCT_PRINTER_PROOF_SEARCH);
        }
        next();
    },
    computed: {
        ...mapState(PRODUCT_PRINTER_PROOF_MODULE, ["status"]),
        ...mapState(LOOKUP_MODULE),
        productDdl() {
            return this.$store.state.lookup.productDdl;
        },
    },
    data() {
        return {
            title: i18n.t("label.createX", [i18n.t("module.printerProof")]),
            options: [
                { value: 0, text: 'Query' },
                { value: 1, text: 'Reply' }
            ],
            items: [
                {
                    text: i18n.t('module.dashboard'),
                    href: "/",
                },
                {
                    text: i18n.t("module.printerProof"),
                    href: "/product-printer-proof",
                },
                {
                    text: i18n.t("label.createX", [i18n.t("module.printerProof")]),
                    active: true,
                },
            ],
            submitted: false,
            statusDdl: ddlHelper.getActivationStatus(false, true),
            selectedOffDays: [], // This will hold the full objects selected in the multiselect
            weekDayDdl: ddlHelper.getWeekDays(),
            permissions: sessionHelper.getPermissions(),
            createPermission: null,
            isCloseWhenSuccess: false,
            createForm: {
                remark: "",
                productID: "",
                type: "",
                date: "",
            },
        };
    },
    validations: {
        createForm: {
            type: { required },
            productID: { required },
            date: { required }
        },
    },
    async created() {
        await this.validPermissions();
        this.searchCriteria = sessionHelper.retrieveSearch(SESSION.PRODUCT_SPECIAL_SEARCH);
        await this.lookupProduct({ hasOptionAll: false });

        if (this.searchCriteria != null) {
            this.createForm.productID = this.$store.state.lookup.productDdl.filter(item => item.value === this.searchCriteria.selectedRecordId);

            if( this.createForm.productID != null && this.createForm.productID.length > 0) {
                this.isCloseWhenSuccess = true; 
            }

            if (this.searchCriteria != null && this.searchCriteria != '' && this.searchCriteria.selectedRecordId == null) {
                sharedHelper.alertErrorMessageWithoutCode("Invalid Product ID, Please Contact Admin")
            }
        }
    },
    methods: {
        ...productPrinterProofMethods,
        ...lookupMethods,
        async validPermissions() {
            var jsonPermissions = JSON.parse(this.permissions)
            if (jsonPermissions.some(p => p.code === "RND_PPP_PPPC")) {
                this.createPermission = true;
            }
            else {
                this.createPermission = false;
            }
        },
        updateImage(image) {
            this.createForm.file = image[0].file;
        },
        async requestCreate() {
            this.submitted = true;
            // stop here if form is invalid
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            } else {
                let isCloseWhenSuccess = this.isCloseWhenSuccess;
                let data = {
                    remark: this.createForm.remark,
                    productID: this.isCloseWhenSuccess == true ? this.createForm.productID[0].value : this.createForm.productID.value,
                    type: this.createForm.type.value,
                    date: this.createForm.date,
                };
                if (this.createPermission == true) {
                    await this.createProductPrinterProof({ data, isCloseWhenSuccess });
                }
            }
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="requestCreate" v-if="createPermission == true">
                            <div class="row">
                                <div class="col-md-6">
                                    <b-form-group id="productID" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.product')" label-for="productID">
                                        <multiselect v-model="createForm.productID"
                                            deselect-label="Can't remove this value" track-by="value" label="text"
                                            placeholder="Select one" :options="productDdl" :searchable="true"
                                            :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.productID.required"
                                            class="invalid-feedback" style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.product")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="type" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('module.type')" label-for="type">
                                        <multiselect v-model="createForm.type" deselect-label="Can't remove this value"
                                            track-by="value" label="text" placeholder="Select one" :options="options"
                                            :searchable="true" :allow-empty="false">
                                        </multiselect>
                                        <div v-if="submitted && !$v.createForm.type.required" class="invalid-feedback"
                                            style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("module.type")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="remark" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.remark')" label-for="remark">
                                        <textarea v-model="createForm.remark" class="form-control" name="textarea"
                                            rows="5"></textarea>
                                    </b-form-group>
                                </div>

                                <div class="col-md-6">
                                    <b-form-group id="date" label-cols-sm="4" label-cols-lg="4"
                                        :label="$t('label.date')" label-for="date">
                                        <date-picker v-model="createForm.date" type="date" format="YYYY-MM-DD"
                                            value-type="format" placeholder="Select date"></date-picker>
                                        <div v-if="submitted && !$v.createForm.date.required" class="invalid-feedback"
                                            style="display: block;">
                                            <span>{{ $t("message.requiredX", [$t("label.date")]) }}</span>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="mt-4 text-center" style="float: right">
                                <button class="btn btn-primary w-md waves-effect waves-light" style="margin-right: 10px"
                                    type="submit" :disabled="status.create">
                                    {{ $t("label.createX", [$t("module.printerProof")]) }}
                                </button>
                            </div>
                        </form>
                        <div style="text-align: center;" v-else>
                            {{ $t('message.noPermissionMessage') }}
                        </div>
                    </div>
                </div>
                <!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </Layout>
</template>